export default "__VITE_ASSET__CuNdZ4oZ__"